import {useQuery, useQueryClient} from '@tanstack/react-query';

export function useAlertCategoryFilter() {
  const queryClient = useQueryClient();

  const queryKey = ['alertCategoryFilter'];
  const defaultFilter = {alertCategory: null, alertBucket: null};

  // Use useQuery to manage the state
  const {data: filter = defaultFilter} = useQuery({
    queryKey,
    queryFn: () => queryClient.getQueryData(queryKey) || defaultFilter,
    initialData: defaultFilter,
  });

  interface AlertCategoryFilter {
    alertCategory: string | null;
    alertBucket: string | null;
  }

  const updateAlertCategoryFilter = (filterData: AlertCategoryFilter): AlertCategoryFilter => {
    const newFilter = {...filter, ...filterData};
    queryClient.setQueryData(queryKey, newFilter);
    return newFilter;
  };

  const resetAlertCategoryFilter = () => {
    queryClient.setQueryData(queryKey, defaultFilter);
    return defaultFilter;
  };

  return {filter, updateAlertCategoryFilter, resetAlertCategoryFilter} as const;
}
